import { SetDataSelector } from '@/shared/models/Transaction'

const setDataComponentsSelectors: {
  [K: string]: SetDataSelector
} = {
  // TODO: Use getSchema here and then map from name to component.
  '0x4b80742de2bf82acb3630000': {
    name: 'AddressPermissions:Permissions', // TODO: Better call this displayName
    key: '0x4b80742de2bf82acb3630000',
    keyType: 'Singleton',
    valueContent: 'BitArray',
    valueType: 'bytes',
    component: 'PermissionChange',
  },
  '0x5ef83ad9559033e6e941db7d': {
    name: 'LSP3Profile',
    key: '0x5ef83ad9559033e6e941db7d',
    keyType: 'Singleton',
    valueContent: 'String',
    valueType: 'string',
    component: 'LSP3Profile',
  },
  '0x9afb95cacc9f95858ec44aa8': {
    name: 'LSP7Asset',
    key: '0x9afb95cacc9f95858ec44aa8',
    keyType: 'Singleton',
    valueContent: 'String',
    valueType: 'string',
    component: 'LSP7Asset',
  },
  '0x114bd03b3a46d48759680d81': {
    name: 'LSP4Creators',
    key: '0x114bd03b3a46d48759680d81',
    keyType: 'Singleton',
    valueContent: 'String',
    valueType: 'string',
    component: 'LSP4Creators',
  },
  '0x6de85eaf5d982b4e5da00000': {
    name: 'LSP4CreatorMap',
    key: '0x6de85eaf5d982b4e5da00000',
    keyType: 'Singleton',
    valueContent: 'String',
    valueType: 'string',
    component: 'LSP4CreatorMap',
  },
  '0x715f248956de7ce65e94d9d8': {
    name: 'LSP8Asset',
    key: '0x715f248956de7ce65e94d9d8',
    keyType: 'Singleton',
    valueContent: 'String',
    valueType: 'string',
    component: 'LSP8Asset',
  },
  '0x724141d9918ce69e6b8afcf5': {
    name: 'LSP28TheGrid',
    key: '0x724141d9918ce69e6b8afcf5',
    keyType: 'Singleton',
    valueContent: 'VerifiableURI',
    valueType: 'bytes',
    component: 'LSP28TheGrid',
  },
}

export default setDataComponentsSelectors
